<template>
  <div class="subscription-plans w-100">
    <div class="subscription-plans__header row">
      <img
        :alt="name"
        :src="thumbnailPath"
        height="auto"
        width="50%"
        class="subscription-plans__image"
        data-testid="subscriptionImage"
      >
      <h1 class="subscription-plans__name">
        {{ name }}
      </h1>
      <p class="subscription-plans__desc">
        {{ $t("Wybierz plan abonamentu najbardziej odpowiedni") }}
        <br class="hidden-xs">
        {{ $t("dla Twoich potrzeb") }}
      </p>
    </div>
    <no-ssr>
      <div class="subscription-plans__offers row">
        <div
          class="subscription-plans__offer"
          v-for="product in sortedProducts"
          :key="product.id"
        >
          <span class="label" v-show="product.points === 2">
            {{ $t("Najczęściej wybierany") }}
          </span>
          <span class="label" v-show="product.points === 10">
            {{ $t("Najlepsza cena") }}
          </span>
          <div class="plan-tipe">
            <p class="type">
              {{ $t("Subscription") }}
            </p>
            <h3 class="name">
              {{ product.name }}
            </h3>
            <p class="points">
              {{ product.points }}
            </p>
            <p class="small-text">
              {{ $t("rentals per month") }}
            </p>
            <div class="desc" v-html="product.short_description" />
            <p class="price">
              {{ parseDesc(product.description) | price }}
            </p>
            <p class="small-text2">
              {{ $t("*każdy kolejny ") }}{{ product.final_price | price }}
            </p>
            <add-to-cart
              :text="'Aktywuj Plan'"
              :product="product"
              class="col-xs-12 col-sm-12 col-md-12 uppercase mt15 main-button py10 weight-600"
            />
          </div>
        </div>
      </div>
    </no-ssr>

    <div class="how-it-works">
      <h1 class="benefits-blocks__Header lora">
        <span>{{ $t("How it works") }}</span>&nbsp;
      </h1>
      <div class="steps-wrapper">
        <div class="steps-row">
          <div class="stepsinner">
            <div class="colournumber">
              1
            </div>
            <img
              class="stepsic"
              src="https://e-garderobe.com/assets/jtdb1.svg"
              alt="steps"
            >
            <p class="itemslabel bold uppercase">
              {{ $t("Pick a plan 2") }}
            </p>
          </div>
          <div class="stepsinner">
            <div class="colournumber">
              2
            </div>
            <img
              class="stepsic"
              src="https://e-garderobe.com/assets/jtdb2.svg"
              alt="steps"
            >
            <p class="itemslabel bold uppercase">
              {{ $t("Start subscription") }}
            </p>
          </div>
          <div class="stepsinner">
            <div class="colournumber">
              3
            </div>
            <img
              class="stepsic"
              src="https://e-garderobe.com/assets/jtdb3.svg"
              alt="steps"
            >
            <p class="itemslabel bold uppercase">
              {{ $t("Select styles") }}
            </p>
          </div>
        </div>
        <div class="steps-row">
          <div class="stepsinner">
            <div class="colournumber">
              4
            </div>
            <img
              class="stepsic"
              src="https://e-garderobe.com/assets/abonament-modowy-icons2.svg"
              alt="steps"
            >
            <p class="itemslabel bold uppercase">
              {{ $t("Choose delivery date") }}
            </p>
          </div>
          <div class="stepsinner">
            <div class="colournumber">
              5
            </div>
            <img
              class="stepsic"
              src="https://e-garderobe.com/assets/abonament-modowy-icons5.svg"
              alt="steps"
            >
            <p class="itemslabel bold uppercase">
              {{ $t("Place an order") }}
            </p>
          </div>
          <div class="stepsinner">
            <div class="colournumber">
              6
            </div>
            <img
              class="stepsic"
              src="https://e-garderobe.com/assets/abonament-modowy-icons6.svg"
              alt="steps"
            >
            <p class="itemslabel bold uppercase">
              {{ $t("Delivery to your doorstep") }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="benefits-blocks">
      <h1 class="benefits-blocks__Header" style="text-align: center;">
        {{ $t("Benefity Abonamentu") }}
      </h1>
      <div class="row center-xs">
        <div class="jtd-block">
          <img
            class="svg-benefity"
            src="/assets/jtdbenefity1.svg"
            alt="car logo"
          >
          <p class="block-text">
            {{
              $t(
                "Darmowa dostawa prosto do twojego domu lub biura i łatwy zwrot."
              )
            }}
          </p>
        </div>
        <div class="jtd-block">
          <img
            class="svg-benefity"
            src="/assets/jtdbenefity2.svg"
            alt="checkbox"
          >
          <p class="block-text">
            {{
              $t(
                "Wszystkie rzeczy są czyste, wyprasowane i gotowe do założenia."
              )
            }}
          </p>
        </div>
        <div class="jtd-block">
          <img
            class="svg-benefity"
            src="/assets/jtdbenefity3.svg"
            alt="checkbox"
          >
          <p class="block-text">
            {{ $t("Nie musisz martwić się o pranie i prasowanie.") }}
          </p>
        </div>
      </div>
      <div class="row center-xs">
        <div class="jtd-block">
          <img
            class="svg-benefity"
            src="/assets/jtdbenefity4.svg"
            alt="checkbox"
          >
          <p class="block-text">
            {{
              $t(
                "W końcu masz możliwość noszenia różnych rzeczy bez konieczności ich zakupu."
              )
            }}
          </p>
        </div>
        <div class="jtd-block">
          <img
            class="svg-benefity"
            src="/assets/jtdbenefity5.svg"
            alt="checkbox"
          >
          <p class="block-text">
            {{
              $t(
                "Wypożyczaj spośród tysiąca rzeczy dostępnych w naszej kolekcji."
              )
            }}
          </p>
        </div>
        <div class="jtd-block">
          <img
            class="svg-benefity"
            src="/assets/jtdbenefity6.svg"
            alt="checkbox"
          >
          <p class="block-text">
            {{
              $t(
                "Możesz wstrzymać lub anulować swój abonament w dowolnym momencie."
              )
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddToCart from 'theme/components/core/AddToCart.vue';
import NoSSR from 'vue-no-ssr';
import { getThumbnailCategoryPath as _thumbnailHelper } from '@vue-storefront/core/helpers';

export default {
  components: {
    AddToCart,
    'no-ssr': NoSSR
  },
  name: 'SubscriptionPlans',
  data () {
    return {};
  },
  computed: {
    thumbnailPath () {
      return this.getThumbnail(this.thumbnail, 2000, 400, 'category');
    },
    sortedProducts () {
      let products = this.products;
      return products.sort((a, b) => {
        if (Number(a.points) > Number(b.points)) {
          return 1;
        }
        if (Number(b.points) > Number(a.points)) {
          return -1;
        }
        return 0;
      });
    }
  },
  props: {
    name: {
      type: String,
      required: false,
      default: 'catalog'
    },
    thumbnail: {
      type: String,
      required: false,
      default: ''
    },
    products: {
      type: null,
      required: true
    }
  },
  methods: {
    parseDesc (desc) {
      if (desc) {
        return desc.replace(/<\/?p>/g, '');
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.subscription-plans {
  &__header {
    margin-left: 0;
    margin-right: 0;
    z-index: -1;
    background-color: #eeeee7;
    position: relative;
    flex-basis: 100%;
    max-width: 100%;
    text-align: center;
    object-position: center;
  }
  &__image {
    position: absolute;
    height: 100%;
    object-fit: cover;
    width: 100%;
    bottom: 0;
    z-index: -1;
  }
  &__name {
    flex-basis: 100%;
    max-width: 100%;
    padding-top: 10px;
    font-size: 45px;
    font-weight: 500;
    color: black;
    @media (max-width: 767px) {
      font-size: 24px;
      font-weight: 500;
      margin-top: 0;
      padding-top: 50px;
      color: #333c39;
      text-align: center;
    }
  }
  &__desc {
    flex-basis: 100%;
    max-width: 100%;
    font-size: 16px;
    color: #202020;
    margin-bottom: 200px;
    @media (max-width: 767px) {
      text-align: center;
    }
  }
}
.plan-tipe {
  background-color: #ffffff;
  box-shadow: 0px 0px 0px 1px black;
  transition: all 0.3s ease;
  margin-bottom: 20px;
  &:hover {
    box-shadow: 0px 0px 0px 3px black;
  }
  text-align: center;
  padding: 20px 0 20px 0;
  .type {
    margin: 0;
    text-transform: uppercase;
    font-size: 0.8em;
  }
  .name {
    margin: 5px 0;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 40px;
  }
  .points {
    margin: 0;
    font-size: 50px;
    font-weight: 300;
  }
  .small-text {
    margin: 0;
  }
  .desc {
    /deep/ p {
      margin: 5px 0;
    }
    background: #f0f0f0;
    color: #858585;
    font-size: 0.9em;
    margin: 0;
    min-height: 160px;
    margin-top: 20px;
    margin-bottom: 10px;
    padding: 10px 0;
  }
  .price {
    font-size: 30px;
    margin: 0;
  }
  .small-text2 {
    margin: 0;
    font-size: 0.9em;
  }
}
.subscription-plans__offers {
  margin-top: -170px;
  justify-content: center;
}
.subscription-plans__offer {
  .label {
    position: absolute;
    background-color: #dc1560;
    padding: 10px;
    font-size: 0.7em;
    white-space: nowrap;
    text-transform: uppercase;
    border-radius: 10px;
    color: white;
    font-weight: 500;
    left: 50%;
    transform: translate(-50%, -20px);
  }
  position: relative;
  flex-basis: 330px;
  max-width: 330px;
  padding: 0 15px;
}
.main-button {
  margin-left: auto;
  margin-right: auto;
  width: 80%;
}
.benefits-blocks {
  &__Header {
    text-align: center;
    flex-basis: 100%;
    max-width: 100%;
    font-size: 30px;
    font-weight: 500;
    margin-top: 40px;
    margin-bottom: 60px;
    color: #333c39;
  }
  .jtd-block {
    position: relative;
    -ms-flex-preferred-size: 300px;
    flex-basis: 300px;
    max-width: 300px;
    padding: 0 15px;
  }
  .block-text {
    font-size: 0.8em;
  }
}

.how-it-works {
  background-color: #f8f8f8;
  padding: 40px 20px;
}
.steps-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
.steps-row {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: row;
  }
}
.stepsinner {
  background: white;
  padding: 20px;
  border: 1px solid #e1e1e1;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  font-size: 0.875rem;
  text-align: center;
  width: calc(100% - 20px);
  max-width: 340px;
}
.colournumber {
  background-color: #ede5dd;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
